import React, { useState } from 'react';
import LucideIcon from './LucideIcon';

function FramerTemplateRequestForm({
  title = 'Didn’t find the right Framer template?',
  description = 'Tell us what kind of website you need. If we build a template for it, you’ll be the first to know.',
  headingLevel = 'h2',
  id = 'template-request',
  className = '',
  labels = {},
}) {
  const mailerliteAction =
    'https://assets.mailerlite.com/jsonp/2391268/forms/188879510568961508/subscribe';
  const [step, setStep] = useState(1);
  const [templateRequest, setTemplateRequest] = useState('');
  const [email, setEmail] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const Heading = headingLevel;
  const copy = {
    requestLabel: 'What template should we build next?',
    requestPlaceholder:
      'Example: Framer template for a luxury hotel, accounting firm, dentist, AI SaaS...',
    next: 'Next',
    backLabel: 'Back to template request',
    emailHeading: 'Leave your e-mail so we stay connected.',
    emailLabel: 'Your email',
    emailPlaceholder: 'Your email',
    send: 'Send',
    consent:
      'I agree to receive emails from Give about new Framer templates, web design, SEO, and digital marketing. No generic newsletter filler. I can unsubscribe at any time.',
    success: 'Thanks. If we build a template like this, we’ll let you know.',
    ...labels,
  };

  const hasTemplateRequest = templateRequest.trim().length > 0;
  const canSubmit = email.trim().length > 0 && agreed;

  const handleFutureTemplateRequestSubmit = (event) => {
    if (step === 1) {
      event.preventDefault();

      if (hasTemplateRequest) {
        setStep(2);
      }

      return;
    }

    if (!canSubmit) {
      event.preventDefault();
      return;
    }

    window.setTimeout(() => setSubmitted(true), 250);
  };

  return (
    <div className={`template-lead-content ${className}`.trim()}>
      <Heading>{title}</Heading>
      {description && <p>{description}</p>}

      <form
        className="template-lead-form"
        action={mailerliteAction}
        method="post"
        target="framer-template-mailerlite-submit"
        onSubmit={handleFutureTemplateRequestSubmit}
      >
        <input
          type="hidden"
          name="fields[framer_template_requested]"
          value={templateRequest}
          readOnly
        />
        <input type="hidden" name="ml-submit" value="1" />
        <input type="hidden" name="anticsrf" value="true" />

        {submitted ? (
          <div className="template-lead-success">{copy.success}</div>
        ) : (
          <>
            {step === 1 && (
              <div className="template-lead-step">
                <div className="template-lead-field-row">
                  <input
                    aria-label={copy.requestLabel}
                    id={id}
                    type="text"
                    value={templateRequest}
                    placeholder={copy.requestPlaceholder}
                    onChange={(event) => setTemplateRequest(event.target.value)}
                  />
                  <button
                    className="template-lead-button"
                    type="button"
                    disabled={!hasTemplateRequest}
                    onClick={() => setStep(2)}
                  >
                    {copy.next}
                  </button>
                </div>
              </div>
            )}

            {step === 2 && (
              <div className="template-lead-step">
                <h3 className="template-lead-back-heading">
                  <button
                    type="button"
                    className="template-lead-back"
                    aria-label={copy.backLabel}
                    onClick={() => setStep(1)}
                  >
                    <LucideIcon name="arrowLeft" size={16} strokeWidth={1.75} />
                  </button>
                  {copy.emailHeading}
                </h3>
                <div className="template-lead-field-row">
                  <input
                    aria-label={copy.emailLabel}
                    id={`${id}-email`}
                    name="fields[email]"
                    type="email"
                    value={email}
                    placeholder={copy.emailPlaceholder}
                    autoComplete="email"
                    onChange={(event) => setEmail(event.target.value)}
                  />
                  <button className="template-lead-button" type="submit" disabled={!canSubmit}>
                    {copy.send}
                  </button>
                </div>
                <label className="template-lead-consent">
                  <input
                    type="checkbox"
                    checked={agreed}
                    onChange={(event) => setAgreed(event.target.checked)}
                  />
                  <span>{copy.consent}</span>
                </label>
              </div>
            )}
          </>
        )}
      </form>
      <iframe
        className="template-lead-submit-frame"
        title="Framer template request submission"
        name="framer-template-mailerlite-submit"
      />
    </div>
  );
}

export default FramerTemplateRequestForm;
